import { Box, Button, Dialog, DialogContent, DialogTitle, Typography } from '@mui/material';
import React from 'react';
import Images from '../../Assets/assetHelper';

const NotificationDialog: React.FC<any> = ({ handleClose, open }) => {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      hideBackdrop={true}
      PaperProps={{ sx: { position: 'absolute', top: '5%', right: '0', borderRadius: '12px', minHeight: { xl: '600px', ultraHD: '700px' } } }}
    >
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Typography sx={{ fontSize: { xs: '14px', xxl: '16px', fullHD: '18px', ultraHD: '20px' }, fontWeight: '500', color: '#373A45' }}>Notifications</Typography>
          <Button sx={{ fontSize: { xs: '12px', fullHD: '13px', ultraHD: '14px' }, fontWeight: '500', color: '#604797', cursor: 'pointer' }}>Mark all as read</Button>
        </Box>
      </DialogTitle>
      <DialogContent sx={{ height: '100%', minHeight: '500px' }}>
        <Box sx={{ height: '500px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
          <img src={Images.Svg.notificationEmpty} alt="Notifications Empty" />
          <Typography sx={{ fontSize: { xs: '12px', fullHD: '14px', ultraHD: '16px' }, fontWeight: '400', color: '#333333', mt: '50px' }}>
            You're all caught up! No new notifications at the moment.
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default NotificationDialog;
